export default function numberFormat(number, fixed = 2, decPoint = ',', thousandsSep = '.') {
    if ( !number || isNaN(number)) {
        return 0.0.toFixed(fixed).toString().replace(/\./,decPoint);
    }
    return parseFloat(number).toFixed(fixed).toString().replace(/\./, decPoint);
};